import { GenericUtils } from "@/utils/GenericUtils";
import { reportError } from "@/utils/reportError";
import { consumeOAuthRedirectPending } from "@/storage/authentication";
import { useEffect, useState } from "react";

export function useDuplicateTabGuard() {
  const [tabValidated, setTabValidated] = useState(false);

  useEffect(() => {
    try {
      let tabId = window.name;
      const stored = sessionStorage.getItem("app_session_id");

      if (!tabId) {
        // Safari clears window.name on cross-origin navigation (e.g. the OAuth redirect
        // round trip to the login domain and back), so an empty window.name here doesn't
        // always mean a new/duplicated tab. If we know we just returned from our own
        // login redirect, trust the still-present sessionStorage id instead of generating
        // a new one, which would otherwise look like a duplicate tab and wipe the session.
        const returningFromAuthRedirect = consumeOAuthRedirectPending();
        tabId = returningFromAuthRedirect && stored ? stored : GenericUtils.generateKey();
        window.name = tabId;
      }

      if (!stored) {
        sessionStorage.setItem("app_session_id", tabId);
      } else if (stored !== tabId) {
        sessionStorage.clear();
        window.location.reload();
        return;
      }

      if (import.meta.env.DEV) {
        console.log("App start - Tab ID:", window.name);
        console.log("App start - Stored ID:", stored);
      }
    } catch (error) {
      reportError(error, {
        eventName: "DUPLICATED-TAB",
        properties: {
          reason: `Error duplicating tab: ${error}`,
        },
      });
      window.name = GenericUtils.generateKey();
    } finally {
      setTabValidated(true);
    }
  }, []);

  return { tabValidated };
}
